import styled from 'styled-components';

const Wrapper = styled.div`
  background: #626262;
  border-radius: 8px;
  padding: 0.5rem;
`;

export default Wrapper;
